export class BfKey {
  constructor({ key }) {
    if (!key) {
      throw new Error('key is required');
    }
    this.key = key;
  }
}
